import React, { useState, useEffect, useRef } from "react";
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from "react-router-dom";
import { Col, Row, Form, Input, Card, Affix, message } from "antd";
import { debounce } from "lodash";
// import { useShortcuts } from "react-shortcuts-hook";
import { useHotkeys } from "react-hotkeys-hook";

import Lyric from "./Lyric";
// import Scroll from "react-scroll-to-element";

const key_memoOnSearch = "memoOnSearch";

export default () => {
  const [status, setStatus] = useState();
  const [seq, setSeq] = useState(null);
  const [list, setList] = useState([]);
  const [docD, setDocD] = useState({ offsetHeight: 0, scrollTop: 0 });

  const [searchInput, setSearchInput] = useState(null);
  const debouncedValue = useDebounce(searchInput, 500);

  const inputEl = useRef(null);

  const history = useHistory();
  const { pathname } = useLocation();
  const { path, url } = useRouteMatch();

  const onChange = (e) => {
    setList([]);
    setStatus("validating");
    setSearchInput(e.target.value);
    // console.log({ location });
  };
  const postSearch = () => {
    setSeq(null);

    sessionStorage.removeItem(key_memoOnSearch);
    history.push(`${url}`);

    // console.log("postSearch");
  };

  useEffect(() => {
    if (debouncedValue !== null) {
      const aController = new AbortController();
      const v = debouncedValue.replace(/\s/g, "");
      if (!!v) {
        // console.log("!!", input, status);

        (async () => {
          const params = new URLSearchParams();
          params.append("search_text", v);

          const { protocol, host } = window.location;
          const inputUrl = new URL(
            `${
              process.env.NODE_ENV === "production"
                ? `${protocol}//${host}`
                : "https://ytg.kr"
            }/api/quick-praise/search`
          );
          inputUrl.search = params.toString();

          try {
            const listSubject = await fetch(inputUrl, {
              signal: aController.signal,
            }).then((response) => response.json());

            setList(
              listSubject.map((s) => ({ qsIdx: s.qs_idx, qsTitle: s.qs_title }))
            );
            setStatus(listSubject.length ? "success" : "warning");
          } catch (err) {
            setStatus("error");
            message.error(err.message);
          }

          postSearch();
        })();
      } else {
        // setList([]);
        setStatus();

        postSearch();
      }

      return () => {
        aController.abort();
        // console.log("cancel", debouncedValue);
      };
    }
    // eslint-disable-next-line
  }, [debouncedValue]);

  const scrollTo = debounce((idx) => {
    const el = document.getElementById(`song-${idx}`);
    if (el) {
      let target = el.offsetTop - 150;

      if (docD.scrollTop < target) {
        target = null;
      }
      if (docD.scrollTop + docD.offsetHeight < el.offsetTop + 150) {
        target = el.offsetTop - docD.offsetHeight + 150;
      }
      // console.log(docD, el.offsetTop, target);

      if (target !== null) {
        window.scroll({ top: target, behavior: "smooth" });
        setTimeout(() => {
          onResizeOrScroll();
        }, 500);
      }
    }
  }, 100);

  const getLyric = async (_seq) => {
    const song = list[_seq];
    // console.log(song);
    sessionStorage.setItem(
      key_memoOnSearch,
      JSON.stringify({
        seq: _seq,
        scrollTop: document.documentElement.scrollTop,
      })
    );

    const lenPathname = pathname.length;
    window.scroll({
      top: 0,
      behavior: lenPathname > 1 ? undefined : undefined /*"smooth"*/,
    });
    history[lenPathname > 1 ? "replace" : "push"](`${url}${song.qsIdx}`);
  };
  const decr = (weight = 1) => {
    const target = seq === null || seq <= weight ? 0 : seq - weight;
    setSeq(target);
    scrollTo(target);
  };
  const incr = (weight = 1) => {
    const target =
      seq === null
        ? 0
        : seq >= list.length - (weight + 1)
        ? list.length - 1
        : seq + weight;
    setSeq(target);
    scrollTo(target);
  };

  const onResizeOrScroll = debounce(() => {
    const { offsetHeight, scrollTop, clientWidth } = document.documentElement;
    const lyricContainerEl = document.getElementById("container-lyrics");

    setDocD({
      offsetHeight,
      scrollTop,
      clientWidth,
      lyricFontSize: (lyricContainerEl.clientWidth / clientWidth) * 5,
    });
  }, 100);

  useEffect(() => {
    // this.obj = { temp: 0 };
    window.addEventListener("resize", onResizeOrScroll);
    window.addEventListener("scroll", onResizeOrScroll);
    onResizeOrScroll();

    inputEl.current.focus();

    return () => {
      window.removeEventListener("resize", onResizeOrScroll);
      window.removeEventListener("scroll", onResizeOrScroll);
    };
    // eslint-disable-next-line
  }, []);
  // useEffect(() => {
  // scrollTo(seq);
  // }, [docD, scrollTo]);
  useEffect(() => {
    if (pathname.length === 1) {
      const memo = JSON.parse(sessionStorage.getItem(key_memoOnSearch));
      if (memo) {
        setSeq(memo.seq);
        window.scroll({ top: memo.scrollTop });
      }
      // console.log(memo);
    }
  }, [pathname]);

  // useEffect(() => {
  //   console.log({ seq });
  // }, [seq]);

  useHotkeys(
    "up",
    (ev) => {
      ev.preventDefault();
      decr();
    },
    {},
    [seq]
  );
  useHotkeys(
    "pageup",

    (ev) => {
      ev.preventDefault();
      decr(10);
    },
    {},
    [seq]
  );
  useHotkeys(
    "down",
    (ev) => {
      ev.preventDefault();
      incr();
    },
    {},
    [seq, list]
  );
  useHotkeys(
    "pagedown",
    (ev) => {
      ev.preventDefault();
      incr(10);
    },
    {},
    [seq, list]
  );

  useHotkeys(
    "enter",
    (ev) => {
      // console.log({ list, seq });

      if (seq !== null) {
        getLyric(seq);
      }
    },
    {},
    [seq]
  );

  return (
    <Row>
      <Col
        xs={pathname.length > 1 ? 0 : 24}
        sm={pathname.length > 1 ? 0 : 15}
        md={11}
        lg={8}
        xl={7}
        xxl={5}
        style={{ marginTop: 10, paddingRight: 10, paddingLeft: 10 }}
      >
        <Form>
          <Affix offsetTop={10} offsetBottom={10}>
            <Form.Item hasFeedback validateStatus={status}>
              <Input
                ref={inputEl}
                placeholder="input the keyword here"
                size="large"
                style={{ fontSize: `${docD.lyricFontSize}vw` }}
                onChange={onChange}
                onKeyDown={(ev) => {
                  // console.log(ev.key);
                  switch (ev.key) {
                    case "ArrowUp":
                      ev.preventDefault();
                      decr();
                      break;
                    case "PageUp":
                      ev.preventDefault();
                      decr(10);
                      break;
                    case "ArrowDown":
                      ev.preventDefault();
                      incr();
                      break;
                    case "PageDown":
                      ev.preventDefault();
                      incr(10);
                      break;
                    case "Enter":
                      ev.preventDefault();
                      if (seq !== null) {
                        getLyric(seq);
                      }
                      break;
                    default:
                    //Nothing
                  }
                }}
              />
            </Form.Item>
          </Affix>
        </Form>

        {list.map((s, i) => (
          <Card
            id={`song-${i}`}
            key={i}
            size="small"
            style={{
              marginBottom: 4,
              borderWidth: 2,
              borderStyle: "dashed",
              borderColor: seq === i ? "gray" : "transparent",
            }}
            hoverable={true}
            onMouseEnter={() => {
              // setSeq(i);
            }}
            onClick={() => {
              setSeq(i);
              getLyric(i);
            }}
          >
            {s.qsTitle}
          </Card>
        ))}
      </Col>
      <Col
        xs={24}
        sm={15}
        md={11}
        lg={8}
        xl={7}
        xxl={5}
        style={{ marginTop: 10, paddingRight: 10, paddingLeft: 10 }}
        id="container-lyrics"
      >
        <Switch>
          <Route path={`${path}:songId`}>
            <Lyric fontSize={docD.lyricFontSize} />
          </Route>
        </Switch>
      </Col>
    </Row>
  );
};

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      // setTimeout을 통해 delay 이후에 debouncedValue를 얻습니다.
      const timer = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      return () => {
        clearTimeout(timer); // 이 전의 timer를 clear합니다.
      };
    },
    // eslint-disable-next-line
    [value] // value 값이 변경될때만 실행됩니다.
  );

  return debouncedValue;
};
